import React from "react";
import { motion } from "framer-motion";
import { Star, TrendingUp } from "lucide-react";

const testimonials = [
  {
    name: "Rakesh Patel",
    role: "Owner, Patel Mobile Hub",
    city: "Surat",
    quote:
      "Within 6 weeks of launching the new site, walk-in customers said they found us on Google. Inquiries jumped 40%.",
    metric: "+40% inquiries",
  },
  {
    name: "Dr. Anjali Menon",
    role: "Founder, Menon Skin Clinic",
    city: "Bengaluru",
    quote:
      "The booking form on the website now fills my morning slots. It looks more premium than my competitors' websites.",
    metric: "2x bookings/mo",
  },
  {
    name: "Karthik Rao",
    role: "MD, Rao Real Estate",
    city: "Mangalore",
    quote:
      "Listings get shared on WhatsApp directly from my site. I closed three deals in the first month — fully online.",
    metric: "3 deals in 30d",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="max-w-2xl mb-16">
          <div className="text-[11px] tracking-[0.2em] uppercase text-[#D4AF37] mb-4">
            Real Results
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-light text-white">
            Businesses already <span className="gold-text italic">winning online.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              data-testid={`testimonial-${i}`}
              className="glass rounded-3xl p-7 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <Star key={idx} className="w-4 h-4 text-[#D4AF37] fill-[#D4AF37]" />
                ))}
              </div>
              <p className="font-display text-lg text-white leading-relaxed mb-6">
                "{t.quote}"
              </p>
              <div className="mt-auto pt-6 border-t border-white/5 flex items-center justify-between">
                <div>
                  <div className="text-sm text-white font-medium">{t.name}</div>
                  <div className="text-xs text-[#737373] mt-0.5">
                    {t.role} · {t.city}
                  </div>
                </div>
                <div className="flex items-center gap-1.5 text-[#D4AF37] text-sm font-medium">
                  <TrendingUp className="w-3.5 h-3.5" />
                  {t.metric}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
